import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CurrentStatusSection.css";
import UndrLineText2 from "../underline/UndrLineText2";
import { useLanguage } from "../LanguageContext";

const CurrentStatusSection = () => {
  const gujaratiTabs = [
    { key: "chairman", label: "ચેરમેન" },
    { key: "director", label: "ડિરેક્ટર" },
    { key: "exDirector", label: "માજી ડિરેક્ટર" },
    { key: "delegates", label: "ડેલિગેટ્સ" },
    { key: "managing_director", label: "મેનેજિંગ ડિરેક્ટર" },
    { key: "social_org", label: "સામાજિક સંસ્થાઓ" },
  ];

  const englishTabs = [
    { key: "chairman", label: "Chairman" },
    { key: "director", label: "Director" },
    { key: "exDirector", label: "Ex.Director" },
    { key: "delegates", label: "Delegates" },
    { key: "managing_director", label: "Managing Director" },
    { key: "social_org", label: "Social Organizations" },
  ];

  const gujaratiData = {
    chairman: [
      {
        text1:
          "ધી ખેડા જિલ્લા મધ્યસ્થ સહકારી બઁક લી. નડિયાદ (કે. ડી.સી. સી બઁક)",
        text2: "2023 થી અત્યાર સુધી (ડીરેક્ટર 2006 -2023)",
      },
      {
        text1: "ધી ગુજરાત સ્ટેટ કો ઓપેરટીવ ટોબેકો ફેડરેશન લી. આણંદ",
        text2: "સન 2022 થી અત્યાર સુધી ,ડીરેક્ટર 2017-2022",
      },
      {
        text1:
          "ધી પેટલાદ સોજીત્રા તાલુકા સૌર ઉર્જા ઉત્પાદક સહકારી મંડળી લી,પેટલાદ",
        text2: "સન 2018 થી અત્યાર સુધી",
      },
      {
        text1:
          "ધી પેટલાદ તાલુકા ખેતી વિકાંસ ઔધ્યોગિક સેવા સહકારી મંડળી લી. પેટલાદ ",
      },
      {
        text1: "ધી પીપળાવ દૂધ ઉત્પાદક સહકારી મંડળી લી. પીપળાવ",
        text2: "સન 2014 થી અત્યાર સુધી",
      },
      {
        text1: "ધી પીપળાવ ગામ વિકાસ મંડળી લી. પીપળાવ",
        text2: "સન 1998 થી અત્યાર સુધી",
      },
      {
        text1: "ધી પીપળાવ સૌર ઉર્જા ઉત્પાદક સહકારી મંડળી લી,પેટલાદ",
        text2: "સન 2018 થી અત્યાર સુધી",
      },
      {
        text1: "ધી પીપળાવ પ્રાકૃતિક ખેતી સહકારી મંડળી લી,પેટલાદ",
        text2: "સન 2022  થી અત્યાર સુધી",
      },
    ],
    director: [
      {
        text1: "ધી ગુજરાત સ્ટેટ કો ઓપરેટીવ બઁક લી ,અમદાવાદ  (જી. એસ. સી બેંક)",
        text2: "સન 2022  થી અત્યાર સુધી",
      },
      {
        text1: "ધી પેટલાદ સોજીત્રા તાલુકા સહકારી ખરીદ વેચાણ સંઘ લી,પેટલાદ",
        text2: "સન 1998  થી અત્યાર સુધી",
      },
      {
        text1:
          "ધી ગુજરાત સ્ટેટ કો ઓપરેટીવ માર્કેટિંગ ફેડરેશન લી ,અમદાવાદ  (ગુજકોમાંશોલ)",
        text2: "સન 2004  થી અત્યાર સુધી",
      },
      {
        text1:
          "મા. સહ મંત્રી ગુજરાત નિયંત્રિત બજાર સંઘ ,અમદાવાદ (જી. આર. એમ. એફ )",
        text2: "સન 2022  થી અત્યાર સુધી",
      },
      {
        text1: "ધી જામનગર ડિસ્ટ્રિકટ કો-ઓપરેટીવ બઁક લી. જામનગર",
        text2: "સન 18/10/2022   થી અત્યાર સુધી",
      },
      {
        text1: "ધી ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,પેટલાદ",
        text2: "સન 2012 થી અત્યાર સુધી(ચેરમેન 2012-2021)",
      },
      {
        text1: "ધી પીપળાવ સેવા સહકારી મંડળી લી,પેટલાડ",
        text2: "સન 2022  થી અત્યાર સુધી",
      },
      {
        text1: "ધી પીપળાવ તમાકુ ઉત્પાદક સહકારી મંડળી લી,પેટલાદ",
        text2: "સન 2011   થી અત્યાર સુધી",
      },
    ],
    exDirector: [
      {
        text1: "ધી ખેડા જિલ્લા સહકારી દૂધ ઉત્પાદક સંઘ લી. આણંદ (અમૂલ)",
        text2: "સન 2015-2020",
      },
    ],
    delegates: [
      {
        text1: "ઇન્ડિયન ફાર્મર ફર્ટિલાઇઝર કો-ઓપરેટિવ લી. ન્યુ દિલ્હી (ઇ ફકો ) ",
        text2: "",
      },
      {
        text1: "કૃષક ભારતી કો ઓપેરટીવ લી  ન્યુ દિલ્હી (ક્રુભકો)",
        text2: "",
      },
    ],
    managing_director: [
      {
        text1: "ભક્તિબાગ (ઓર્ગેનિક ફાર્મ )પીપળાવ",
        text2: "",
      },
    ],
    social_org: [
      {
        text1:
          " ટ્રસ્ટી - લક્ષ્મી નારાયણ દેવ ચેરિટેબલ ટ્રસ્ટ વડતાલ (શ્રી સ્વામિનારાયણ ભગવાન ગાદી સ્થાન)",
        text2: "",
      },
      {
        text1:
          "અકજિકયુટીવ ડિરેક્ટર ચરોતર મોટી સત્યાવીસ લેઉવા પાટીદાર સમાજ માતૃ સંસ્થા",
        text2: "",
      },
    ],
  };

  const englishData = {
    chairman: [
      {
        text1:
          "The Kheda District Central Cooperative Bank Ltd. Nadiad (K.D.C. Bank)",
        text2: "Year 2023 to present (Director 2006 -2023)",
      },
      {
        text1: "The Gujarat State Cooperative Tobacco Federation Ltd. Anand",
        text2: " Year 2022 to present, Director 2017-2022",
      },
      {
        text1:
          "The Petlad Sojitra Taluka Solar Energy Producers Cooperative Society Ltd., Petlad",
        text2: "Year 2018 to present",
      },
      {
        text1:
          "The Petlad Taluka Agriculture Development Industrial Service Cooperative Society Ltd. Petlad",
      },
      {
        text1: "The Piplav Milk Producers Cooperative Society Ltd. Piplav",
        text2: "Year 2014 to present",
      },
      {
        text1: "The Piplav Village Development Society Ltd. Piplav",
        text2: "Year 1998 to present",
      },
      {
        text1:
          "The Piplav Solar Energy Producers Cooperative Society Ltd., Petlad",
        text2: "Year 2018 to present",
      },
      {
        text1:
          "The Piplav Natural Agriculture Cooperative Society Ltd., Petlad",
        text2: "Year 2022 to present",
      },
    ],
    director: [
      {
        text1:
          "The Gujarat State Co-operative Bank Ltd., Ahmedabad (G. S. C. Bank)",
        text2: "2022 to present",
      },
      {
        text1:
          "The Petlad Sojitra Taluka Co-operative Purchase and Sale Society Ltd., Petlad",
        text2: "1998 to present",
      },
      {
        text1:
          "The Gujarat State Co-operative Marketing Federation Ltd., Ahmedabad (Gujkomanshol)",
        text2: "2004 to present",
      },
      {
        text1:
          "Mr. Joint Minister Gujarat Controlled Market Federation, Ahmedabad (G. R. M. F)",
        text2: "2022 to present",
      },
      {
        text1: "The Jamnagar District Co-operative Bank Ltd. Jamnagar",
        text2: "18/10/2022 to present",
      },
      {
        text1: "The Agricultural Produce Market Committee, Petlad",
        text2: "2012 to present (Chairman 2012-2021)",
      },
      {
        text1: "The Piplav Seva Co-operative Society Ltd., Petlad",
        text2: "2022 to present",
      },
      {
        text1: "The Piplav Tobacco Producers Co-operative Society Ltd., Petlad",
        text2: "2011 to present",
      },
    ],
    exDirector: [
      {
        text1:
          "The Kheda District Cooperative Milk Producers Union Ltd. Anand (Amul)",
        text2: "Year 2015-2020",
      },
    ],
    delegates: [
      {
        text1: "Indian Farmer Fertilizer Co-operative Ltd. New Delhi (IFCO)",
        text2: "",
      },
      {
        text1: "Krishak Bharti Co-operative Ltd. New Delhi (KRUBHCO)",
        text2: "",
      },
    ],
    managing_director: [
      {
        text1: "Bhakti Bagh (Organic Farm) Piplav",
        text2: "",
      },
    ],
    social_org: [
      {
        text1:
          "Trustee - Laxminarayan dev charitable trust vadtal (shri swaminarayan bhagvan gadi sthan)",
        text2: "",
      },
      {
        text1:
          "Executive Director Charotar Moti Satyavis Leuva Patidar Samaj Matar Sanstha",
        text2: "",
      },
    ],
  };

  const [activeTab, setActiveTab] = useState("chairman");
  const [homeData, setHomeData] = useState({});
  const [tabs, setTabs] = useState([]);
  const { language } = useLanguage(); // Assuming language = true for English, false for Gujarati
  const [isMobile, setIsMobile] = useState(false); // New state for mobile detection

  // Create a ref for the content area
  const contentRef = useRef(null);

  useEffect(() => {
    if (language) {
      setHomeData(englishData);
      setTabs(englishTabs);
    } else {
      setHomeData(gujaratiData);
      setTabs(gujaratiTabs);
    }
  }, [language]);

  // Function to check if it's a mobile screen
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768); // Adjust breakpoint as needed
  };

  // Effect to add/remove resize listener and set initial mobile status
  useEffect(() => {
    handleResize(); // Set initial state
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty dependency array means this runs once on mount and unmount

  // Effect to scroll to content when activeTab changes, but only on mobile
  useEffect(() => {
    if (isMobile && contentRef.current) {
      // Only scroll if it's a mobile screen
      contentRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [activeTab, isMobile]); // Trigger scroll when activeTab or isMobile changes

  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey);
  };

  return (
    <div className="col-11 m-auto row bg-white mt-5">
      <div className="text-start mb-4 d-flex">
        <h2
          className="text-heading fw-bold"
          style={{ fontSize: "50px", color: "#1D2344" }}
        >
          {language ? (
            <>
              Current <br />
              <UndrLineText2
                text="Position & Work"
                className="text-color-oreng"
              />
            </>
          ) : (
            <>
              વર્તમાન <br />
              <UndrLineText2
                text="સ્થિતિ અને કાર્ય"
                className="text-color-oreng"
              />
            </>
          )}
        </h2>
      </div>

      {/* Tabs */}
      <div className="d-flex flex-wrap justify-content-center">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`btn p-2 btn-outline-dark rounded-0 flex-grow-1 m-2`}
            style={{
              border: "2px solid #1D2344",
              backgroundColor:
                activeTab === tab.key ? "#1D2344" : "transparent",
              color: activeTab === tab.key ? "white" : "#1D2344",
              borderRadius: "5px",
              fontWeight: "bold",
              minWidth: "120px",
              fontSize: "24px",
            }}
            onClick={() => handleTabClick(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content - Attach the ref here */}
      <div ref={contentRef}>
        <div className="row row-cols-1 row-cols-md-2 mt-4 g-3">
          {homeData?.[activeTab]?.length > 0 ? (
            homeData[activeTab].map((item, index) => (
              <div className="col content-wrapper mt-2" key={index}>
                <div className="side-text-div"></div>
                <div className="p-2 px-3 text-start">
                  <p className="m-0 blu">{item.text1}</p>
                  <p className="m-0 blu">{item.text2}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center col-12">
              <p></p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CurrentStatusSection;
